import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SidebarTaskUi } from 'src/app/routes/routes-with-sidebar/shared/components/sidebar/model/sidebar.model';
import { CurrencyPipe } from '@angular/common';
import { TaskDateLabelComponent } from 'src/app/shared/components/task-date-label/task-date-label.component';

@Component({
  selector: 'ri-resolution-ui-review-task-template',
  templateUrl: './review-task-template.component.html',
  imports: [CurrencyPipe, TaskDateLabelComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReviewTaskTemplateComponent {
  readonly task = input.required<SidebarTaskUi>();
}
